import { type MouseEvent, type FC } from 'react'
import { Button } from 'shared/ui'
import { useConversationListContext } from 'pages/conversations/ui/ConversationList/context'

type IButtonTransferProps = {
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  clickCallback?: () => void
  conversationIds: number[]
}

export const ButtonTransfer: FC<IButtonTransferProps> = ({
  onMouseLeave,
  onMouseEnter,
  clickCallback,
  conversationIds,
}) => {
  const store = useConversationListContext()
  const { transferConversation, transferConversationModalStore } = store

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    transferConversation(conversationIds, transferConversationModalStore)
    clickCallback?.()
  }

  return (
    <Button
      fontWeight={400}
      onClick={handleClick}
      typeBtn='menuItem'
      icon={'transfer'}
      text={'Transfer conversation'}
      fullWidth
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
